import {
  DialogContent as MuiDialogContent,
  DialogContentProps as MuiDialogContentProps,
  styled,
} from "@mui/material";

const StyledDialogContent = styled(MuiDialogContent)(() => ({
  // ... existing styles
}));

interface DialogContentProps extends MuiDialogContentProps {
  children: React.ReactNode;
}

export const DialogContent: React.FC<DialogContentProps> = ({ children, ...props }) => {
  return <StyledDialogContent {...props}> {children}</StyledDialogContent>;
};

export default DialogContent;
